export enum EnrollmentStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
}

export enum LessonState {
  DONE = 'DONE',
  CURRENT = 'CURRENT',
  NOT_SEEN = 'NOT_SEEN',
}

export enum LessonKind {
  VIDEO = 'VIDEO',
  TEXT = 'TEXT',
  TEXT_AND_PDF = 'TEXT_AND_PDF',
}

export enum LessonBlockKind {
  VIDEO = 'VIDEO',
  TEXT = 'TEXT',
  PDF = 'PDF',
  ATTACHMENTS = 'ATTACHMENTS',
}

export enum CourseTag {
  OPERATIONS = 'OPERATIONS',
  TECHNOLOGY = 'TECHNOLOGY',
  FINANCE = 'FINANCE',
}

export enum CourseStatusTab {
  ALL = 'ALL',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  DONE = 'DONE',
}

export type LessonAttachment = { name: string; typeLabel: string; sizeLabel: string; url: string };

export type LessonBlock =
  | { kind: LessonBlockKind.VIDEO; title: string; embedUrl: string }
  | { kind: LessonBlockKind.TEXT; paragraphs: string[]; bullets: string[]; notice?: string }
  | { kind: LessonBlockKind.PDF; fileName: string; url: string }
  | { kind: LessonBlockKind.ATTACHMENTS; attachments: LessonAttachment[] };

export type LessonRef = {
  id: string;
  number: number;
  title: string;
  moduleNumber: number;
  durationMinutes: number;
  kind: LessonKind;
};

export type MyLesson = LessonRef & {
  state: LessonState;
  blocks: LessonBlock[];
};

export type MyCourseModule = { id: string; number: number; title: string; doneCount: number; lessons: MyLesson[] };

export type MyCourse = {
  id: string;
  title: string;
  description: string;
  tag: CourseTag;
  coverUrl: string;
  coverAlt: string;
  durationMinutes: number;
  moduleCount: number;
  lessonCount: number;
  doneCount: number;
  progressPct: number;
  status: EnrollmentStatus;
  isNew: boolean;
  publishedAt: string;
  updatedAt: string;
  startedAt?: string;
  lastActivityAt?: string;
  completedAt?: string;
  nextLesson?: LessonRef;
};

export type MyCourseDetail = MyCourse & { learningGoals: string[]; modules: MyCourseModule[] };

export type LessonCompletionInput = { lessonId: string; completed: boolean };

export type TeamBoardCourse = {
  id: string;
  shortTitle: string;
  coverUrl: string;
  isNew: boolean;
  doneCount: number;
  openCount: number;
};

export type TeamBoardCell = { status: EnrollmentStatus; progressPct: number };

export type TeamBoardMember = {
  id: string;
  name: string;
  initials: string;
  role: string;
  isCurrentUser: boolean;
  cells: (TeamBoardCell | null)[];
  doneCount: number;
  openCount: number;
};

export type TeamBoard = {
  courses: TeamBoardCourse[];
  members: TeamBoardMember[];
  doneCount: number;
  openCount: number;
  progressPct: number;
  notStartedMemberNames: string[];
};
